import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CodeIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="m13.29 14.62 5-5-5-5m-6.669 0-5 5 5 5"
      />
    </Icon>
  );
}
